import { render } from "./CivilGpt.vue?vue&type=template&id=4dd98b54"
import script from "./CivilGpt.vue?vue&type=script&lang=js"
export * from "./CivilGpt.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__